/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { filterBy, readOnly } from '@ember/object/computed';
import { isEmpty } from '@ember/utils';
import DeliveryModel, { PushDeliveryMetaReason } from 'cio/models/delivery';

const SUCCESS_CODE = 200;

interface PushActionResultsArgs {
  delivery: DeliveryModel;
}

export default class PushActionResults extends Component<PushActionResultsArgs> {
  @readOnly('args.delivery.deviceStatuses') _deliveries!: PushDeliveryMetaReason[];

  @filterBy('_deliveries', 'status', SUCCESS_CODE) _sentDeliveries!: PushDeliveryMetaReason[];

  @filterBy('_deliveries', 'undeliverable', true) _undeliverableDeliveries!: PushDeliveryMetaReason[];

  @filterBy('_deliveries', 'bounced', true) _bouncedDeliveries!: PushDeliveryMetaReason[];

  @filterBy('_deliveries', 'suppressed', true) _suppressedDeliveries!: PushDeliveryMetaReason[];

  // All the deliveries that aren't sent, bounced, or suppressed can be considered failed
  @computed('_deliveries.[]', '_undeliverableDeliveries', '_bouncedDeliveries', '_suppressedDeliveries')
  get _failedDeliveries() {
    return (this._deliveries || []).filter((delivery) => {
      return (
        !this._sentDeliveries.includes(delivery) &&
        !this._undeliverableDeliveries.includes(delivery) &&
        !this._bouncedDeliveries.includes(delivery) &&
        !this._suppressedDeliveries.includes(delivery)
      );
    });
  }

  @computed(
    'args.delivery.{isDrafted,recipientDevices}',
    '_sentDeliveries.[]',
    '_undeliverableDeliveries.[]',
    '_bouncedDeliveries.[]',
    '_suppressedDeliveries.[]',
  )
  get deliveryGroups() {
    let { delivery } = this.args;

    if (delivery.isDrafted) {
      return [{ type: 'drafted', deliveries: delivery.recipientDevices }];
    }

    return [
      { type: 'sent', deliveries: this._sentDeliveries },
      { type: 'undeliverable', deliveries: this._undeliverableDeliveries },
      { type: 'bounced', deliveries: this._bouncedDeliveries },
      { type: 'suppressed', deliveries: this._suppressedDeliveries },
      { type: 'failed', deliveries: this._failedDeliveries },
    ].filter(({ deliveries }) => !isEmpty(deliveries));
  }
}
